{
  "Nul": 0,
  "Een": 1,
  "Twee": 2,
  "Drie": 3,
  "Vier": 4,
  "Vijf": 5,
  "Zes": 6,
  "Zeven": 7,
  "Acht": 8,
  "Negen": 9
}
